import { RequirementTableItemData } from "../types";
import { IRequirement } from "@wingspanhq/payments/dist/interfaces";

export const selectorIsRequirement = (
  data: RequirementTableItemData
): data is IRequirement => {
  return "requirementId" in data;
};
